import { render, staticRenderFns } from "./RoutesMeta.vue?vue&type=template&id=a2f663c0&scoped=true&"
import script from "./RoutesMeta.vue?vue&type=script&lang=js&"
export * from "./RoutesMeta.vue?vue&type=script&lang=js&"
import style0 from "./RoutesMeta.vue?vue&type=style&index=0&id=a2f663c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f663c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f663c0')) {
      api.createRecord('a2f663c0', component.options)
    } else {
      api.reload('a2f663c0', component.options)
    }
    module.hot.accept("./RoutesMeta.vue?vue&type=template&id=a2f663c0&scoped=true&", function () {
      api.rerender('a2f663c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/routes/RoutesMeta.vue"
export default component.exports